<div class="form-check form-switch">
  <input
    #input
    class="n-slide-toggle-input form-check-input"
    type="checkbox"
    role="switch"
    [id]="inputId"
    [required]="required"
    [tabIndex]="tabIndex"
    [checked]="checked"
    [disabled]="disabled"
    [attr.name]="name"
    [attr.aria-checked]="checked"
    [attr.aria-label]="ariaLabel"
    [attr.aria-labelledby]="ariaLabelledby"
    [attr.aria-describedby]="ariaDescribedby"
    (change)="onChangeEvent($event)"
    (click)="onInputClick($event)"
  />
  <label
    [attr.for]="inputId"
    class="form-check-label text-nowrap align-middle"
    #label
    #labelContent
    (cdkObserveContent)="onLabelTextChange()"
  >
    <ng-content></ng-content>
  </label>
</div>
